module.exports = __webpack_public_path__ + "static/media/land_oranje.c4cebd44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/land_oranje.svg
// module id = 608
// module chunks = 0